import { useTranslation } from "react-i18next";
import { AlertInfo } from "src/@/components/shared/AlertInfo";

const CardEnableBot = ({
  changeBlock,
  block,
}) => {
  const { t } = useTranslation('automation');

  return (
    <div className="w-full">
      <div className="space-y-4">
        <div>
          <AlertInfo
            title={t('reactionCards.enableBot.title', 'Reabilitar Bot')}
            description={t('reactionCards.enableBot.description', 'Se houver um chat vinculado, o bot será reabilitado (silenciamento removido) e voltará a responder pela IA.')}
          />
        </div>
      </div>
    </div>
  );
};

export default CardEnableBot;
